import React from 'react';
import { Button } from './ui/Button';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53266912084305:1';
export function VillainSection() {
  const goToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <section className="py-10 px-4 bg-deep-blue text-cream relative overflow-hidden" data-id="element-179">
      {/* Decorative background blur */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-warm-accent/10 rounded-full blur-3xl -z-10" data-id="element-180"></div>

      <div className="max-w-3xl mx-auto text-center z-10 relative" data-id="element-181">
        <h2 className="text-3xl md:text-5xl font-bold mb-5 leading-tight" data-id="element-182">
          No es mala educación. <br className="hidden md:block" data-id="element-183" />
          <span className="text-warm-accent" data-id="element-184">Es un secuestro de dopamina.</span>
        </h2>

        <p className="text-lg md:text-xl text-cream/80 mb-6 leading-relaxed" data-id="element-185">
          Silicon Valley diseña apps para ser adictivas. El cerebro de tu hijo
          no puede luchar solo contra eso. Tú necesitas una estrategia de
          neuro-regulación, no más gritos.
        </p>

        <Button onClick={goToCheckout} className="animate-pulse-soft" data-id="element-186">
          RECUPERA EL CONTROL POR 6,95€
        </Button>
      </div>
    </section>;
}